<template>
  <div class="wizard-nav d-flex justify-content-center align-items-center">
    <div class="connecting-line"></div>
    <div class="progress-line"></div>
    <ul class="nav nav-tabs">
      <li v-for="tab in tabs" :key="tab.id">
        <div href="" class="d-flex flex-column justify-content-center align-items-center">
          <div :class="{
            'wizard-img-container': true,
            'active': this.activeTab >= tab.id,
            'wizard-tab-invalid':  this.$parent.invalidTab.includes(tab.id)
          }">
            <img :src="this.activeTab >= tab.id ? tab.activeIcon : tab.icon" alt="">
          </div>
          <span>{{ tab.label }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
    activeTab: Number,
  },
  methods: {
    changeTab(tabId) {
      this.$emit('change-tab', tabId);
    },
    isActiveTab(tabId) {
      return this.activeTab === tabId;
    },
  },
};
</script>

<style scoped src="./WizardTabs.css"></style>